<template>
  <report-section title="血氧统计" style="position: relative">
    <template v-slot:content>
      <div class="blood-oxygen">
        <!-- 第一行：基础血氧指标 -->
        <div class="blood-oxygen-row">
          <blood-oxygen-unit title="平均血氧饱和度" :value="model.averageBloodOxygenSaturation" unit="%"></blood-oxygen-unit>
          <blood-oxygen-unit title="最低血氧饱和度" :value="model.minBloodOxygenSaturation" unit="%"></blood-oxygen-unit>
          <blood-oxygen-unit title="氧减次数" :value="model.oxygenRadiationTimes" unit=""></blood-oxygen-unit>
          
        </div>
        
        <!-- 第二行：各期氧减指标 -->
        <div class="blood-oxygen-row">
          <blood-oxygen-unit title="氧减指数" :value="model.oxygenRadiationIndex" unit="次/小时"></blood-oxygen-unit>
          <blood-oxygen-unit title="REM期氧减" :value="model.remOxygenReduction" unit=""></blood-oxygen-unit>
          <blood-oxygen-unit title="NREM期氧减" :value="model.nremOxygenReduction" unit=""></blood-oxygen-unit>
        </div>
      </div>
    </template>

  </report-section>
</template>

<script>
import SleepPeriodUnit from "@c/report-detail/sleep-period/sleep-period-unit.vue";
import SleepPeriodTitle from "@c/report-detail/sleep-period/sleep-period-title.vue";
import BloodOxygenUnit from "./blood-oxygen-unit.vue";
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
export default {
  components: {
    SleepPeriodTitle,
    SleepPeriodUnit,
    BloodOxygenUnit,
    ReportSection
  },

  props: {
    model: Object,
  },

  data() {
    return {
      uid: undefined
    }
  },

};
</script>

<style lang="scss" scoped>
.blood-oxygen {
  width: 100%;
  box-sizing: border-box;
  padding: rem(20) rem(20);
  display: flex;
  flex-direction: column;
  gap: rem(20);

  &-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: rem(15);
    
    > * {
      flex: 1;
      min-width: 0;
    }
  }


}
</style>